import { Box, Button } from '@user-portal/wikr-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SUBSCRIPTION_LABEL_STATES } from '../constants';
import { IExpiredSubscription } from '../types';

import { IncludedInYourPlanRow } from './subComponents/IncludedInYourPlanRow';
import PeriodRow from './subComponents/PeriodRow';
import SubscriptionCardHeader from './subComponents/SubscriptionCardHeader';
import SubscriptionStatusLabel from './subComponents/SubscriptionLabel';
import SubscriptionCardWrapper from './SubscriptionCardWrapper';

const ExpiredSubscription = ({
    tabIcon,
    heading,
    subscriptionPeriod,
    isTrial,
    isUpgrade,
    isMainSubscription,
    productCode,
    onRestoreSubscription,
    isOneTimeProduct,
    isPromoCodeUsed,
}: IExpiredSubscription) => {
    const { t } = useTranslation();
    const isRestoreAvailable = isMainSubscription && !isOneTimeProduct && !isPromoCodeUsed;

    return (
        <SubscriptionCardWrapper>
            <Box $mb={20}>
                <SubscriptionCardHeader
                    isMainSubscription={isMainSubscription}
                    productCode={productCode}
                    Icon={tabIcon}
                    heading={heading}
                />
                <SubscriptionStatusLabel state={SUBSCRIPTION_LABEL_STATES.EXPIRED} />
                <PeriodRow period={subscriptionPeriod} color="text-secondary" isTrial={isTrial} />
                {isUpgrade && <IncludedInYourPlanRow />}
            </Box>
            {isRestoreAvailable && (
                <Button dataLocator="restoreSub" onClick={onRestoreSubscription}>
                    {t('subscription.text.restore')}
                </Button>
            )}
        </SubscriptionCardWrapper>
    );
};

export default ExpiredSubscription;
